import { Do, guid, leftpad, timer } from '../../universal';
import { $, _, renderToStaticMarkup } from '../lib';
import { IRIS } from './component-iris';
import { j2h } from './component-j2h';
import { newSystemFlyout } from './flyouts';
export const Alerts = {
    Base: (obj) => {
        if (obj.title == null) {
            obj.title = 'No title given';
        }
        if (obj.msg == null) {
            obj.msg = 'No message given';
        }
        if (obj.buttons == null) {
            obj.buttons = [['OK', 'btnSubmit2', _.noop, true]];
        }
        if (obj.load == null) {
            obj.load = _.noop;
        }
        if (obj.size == null) {
            obj.size = [360, 200];
        }
        if (obj.cl == null) {
            obj.cl = '';
        }
        if (obj.msg && typeof obj.msg === 'object') {
            obj.msg = renderToStaticMarkup(obj.msg);
        }
        const flyout = newSystemFlyout({
            size: obj.size,
            cl: obj.cl,
            closeCallback: obj.no ?? _.noop,
        });
        const $form = $(flyout.Element);
        $form.append(j2h([
            {
                class: 'flyout_header',
                children: [
                    {
                        tag: 'h1',
                        attr: { style: 'display: inline;' },
                        text: obj.title,
                    },
                ],
            },
            {
                class: 'floater_body toDialog',
                children: [
                    { tag: 'p', html: obj.msg },
                    {
                        class: 'buttons cntr',
                        children: _.map(obj.buttons, btn => {
                            const [lbl, class_, onclick, isFocused] = btn;
                            const M = {
                                tag: 'input',
                                class: class_,
                                value: lbl,
                                attr: { type: 'button' },
                                click: () => {
                                    flyout.Close();
                                    onclick?.($form);
                                },
                            };
                            if (isFocused) {
                                M.ev = {
                                    init: elem => timer(() => elem.focus()),
                                };
                            }
                            return M;
                        }),
                    },
                ],
            },
        ]));
        obj.load();
        $form.find('.floater_body');
    },
    Confirm: (obj) => {
        if (obj.title == null) {
            obj.title = 'Are you sure?';
        }
        if (obj.msg == null) {
            obj.msg = 'Are you sure you want to perform this action?';
        }
        if (obj.yes == null) {
            obj.yes = _.noop;
        }
        if (obj.no == null) {
            obj.no = _.noop;
        }
        if (obj.buttons == null) {
            obj.buttons = [
                ['OK', 'btnSubmit2', obj.yes, true],
                ['Cancel', 'btnStandard2', obj.no, false],
            ];
        }
        Alerts.Base(obj);
    },
    ConfirmWithOption: (obj) => {
        if (obj.label == null) {
            console.error('Must define `label` to `ConfirmWithOption`');
        }
        const onYesClick = obj.yes ?? _.noop;
        const thisGUID = guid();
        obj.msg = Do(() => {
            const dom = {
                children: [
                    {
                        tag: 'p',
                        text: obj.msg ?? 'Are you sure you want to perform this action?',
                    },
                    {
                        tag: 'label',
                        class: 'label noselect',
                        children: [
                            {
                                tag: 'input',
                                attr: {
                                    type: 'checkbox',
                                    id: thisGUID,
                                },
                            },
                            String(obj.label ?? 'No label defined'),
                        ],
                    },
                ],
            };
            return j2h(dom).outerHTML;
        });
        obj.yes = $form => {
            const is_checked = $form.find(`[id='${thisGUID}']`)[0].checked;
            onYesClick(is_checked);
        };
        if (obj.title == null) {
            obj.title = 'Are you sure?';
        }
        if (obj.no == null) {
            obj.no = _.noop;
        }
        if (obj.buttons == null) {
            obj.buttons = [
                ['OK', 'btnSubmit2', obj.yes, true],
                ['Cancel', 'btnStandard2', obj.no, false],
            ];
        }
        Alerts.Base(obj);
    },
    Alert: (obj) => {
        if (obj.title == null) {
            obj.title = 'Message';
        }
        if (obj.size == null) {
            obj.size = [300, 190];
        }
        obj.buttons = [['OK', 'btnSubmit2', obj.yes, true]];
        Alerts.Base(obj);
    },
};
export const validateTime = (string) => {
    if (!string) {
        return '';
    }
    string = string.trim();
    if (string.split(':').length == 3) {
        string = string.split(':').slice(0, 2).join(':');
    }
    string = string.replace(/\D/g, '');
    if (string.length === 0) {
        return '';
    }
    if (string.length <= 2) {
        string += '00';
    }
    string = leftpad(string, 4);
    let h = +string.substring(0, 2);
    let m = +string.substring(2, 4);
    if (!(h >= 0 && h <= 24)) {
        h = 0;
    }
    if (!(m >= 0 && m <= 60)) {
        m = 0;
    }
    return `${leftpad(String(h), 2)}:${leftpad(String(m), 2)}`;
};
export const sendErrorsToTelegram = () => {
    window.onerror = (message, url, line, _col, err) => {
        IRIS.Send({
            data: {
                progID: 0,
                funcID: 7,
                browser: navigator?.userAgent ?? 'Unknown',
                message,
                stack: err?.stack ?? null,
                url,
                line,
                location: location.href,
            },
        });
    };
};
export const enableButtons = $btn => {
    $btn = $btn.parent().children('input, button');
    $btn.removeClass('disabled').prop('disabled', false);
};
export const disableButtons = $btn => {
    $btn = $btn.parent().children('input, button');
    $btn.addClass('disabled').prop('disabled', true);
};
let scrollbarWidthCache = null;
export const getScrollbarWidth = () => {
    if (scrollbarWidthCache != null) {
        return scrollbarWidthCache;
    }
    const div = j2h({
        attr: {
            style: 'width:50px;height:50px;position:absolute;left:-50px;top:-50px;overflow:auto;',
        },
        children: [{ attr: { style: 'width:1px;height:100px;' } }],
    });
    document.body.appendChild(div);
    scrollbarWidthCache = div.offsetWidth - div.clientWidth;
    div.remove();
    $('head').append($(`<style>.allButScrollbar{width:calc(100% - ${scrollbarWidthCache}px)}`));
    return scrollbarWidthCache;
};
export const clearScrollbarWidthCache = () => {
    scrollbarWidthCache = null;
};
export const makeDraggable = options => {
    const getElement = v => {
        if (v == null) {
            v = null;
        }
        if (typeof v === 'function') {
            v = v();
        }
        return v;
    };
    const normaliseParameters = () => {
        if (options == null) {
            options = {};
        }
        options = {
            $element: getElement(options.$element),
            $handle: getElement(options.$handle),
            onStart: options.onStart ?? _.noop,
            onDuring: options.onDuring ?? _.noop,
            onStop: options.onStop ??
                (data => {
                    const pos = options.$element.position();
                    options.$element.css({
                        left: pos.left + data.pos.delta.x,
                        top: pos.top + data.pos.delta.y,
                        transform: '',
                    });
                }),
            polling: options.polling ?? 30,
            grid: options.grid ?? 1,
            allowHorizontal: options.allowHorizontal ?? true,
            allowVertical: options.allowVertical ?? true,
            stopProp: options.stopProp ?? true,
            data: options.data ?? {},
        };
        options.data.options = options;
    };
    const getDelta = (o, n) => options.grid * Math.floor((o - n) / options.grid);
    const dragMove = e => {
        const cx = e.pageX ?? e.originalEvent?.touches[0]?.pageX;
        const cy = e.pageY ?? e.originalEvent?.touches[0]?.pageY;
        let dx = getDelta(cx, options.data.pos.init.x);
        let dy = getDelta(cy, options.data.pos.init.y);
        dx = options.allowHorizontal ? dx : 0;
        dy = options.allowVertical ? dy : 0;
        options.data.pos.delta = { x: dx, y: dy };
        options.data.pos.current = {
            x: options.data.pos.init.x + dx,
            y: options.data.pos.init.y + dy,
        };
        options.$element.css({ transform: `translate(${dx}px, ${dy}px)` });
        options.data.event = e;
        options.onDuring(options.data);
    };
    const dragMoveThrottled = _.throttle(dragMove, 30);
    const onMouseMoveThis = e => {
        dragMoveThrottled(e);
    };
    const onMouseUpThis = e => {
        options.data.$window.off('mousemove touchmove', onMouseMoveThis);
        options.data.$window.off('mouseup touchend', onMouseUpThis);
        dragMoveThrottled.cancel();
        options.data.event = e;
        options.onStop(options.data);
    };
    const startDrag = e => {
        if (options.stopProp) {
            e.stopPropagation();
            e.preventDefault();
        }
        normaliseParameters();
        options.data.$window = $(window);
        const cx = e.pageX ?? e.originalEvent?.touches[0]?.pageX;
        const cy = e.pageY ?? e.originalEvent?.touches[0]?.pageY;
        options.data.pos = {
            init: { x: cx, y: cy },
            delta: { x: 0, y: 0 },
            current: { x: cx, y: cy },
        };
        options.data.$window.on('mousemove touchmove', onMouseMoveThis);
        options.data.$window.on('mouseup touchend', onMouseUpThis);
        options.data.event = e;
        options.onStart(options.data);
    };
    return getElement(options.$handle)
        .off('mousedown touchstart', startDrag)
        .on('mousedown touchstart', startDrag);
};
export class DefMap {
    fn;
    map;
    constructor(fn) {
        this.fn = fn;
        this.map = new Map();
    }
    get(key) {
        let val = this.map.get(key);
        if (val === undefined) {
            val = this.fn();
            this.map.set(key, val);
        }
        return val;
    }
    set(key, val) {
        return this.map.set(key, val);
    }
    push(key, newVal) {
        const valObj = this.get(key);
        if (Array.isArray(valObj)) {
            valObj.push(newVal);
        }
        if (valObj.constructor !== Array) {
            throw Error('Cannot use append for non-array values');
        }
    }
    add(key, newVal) {
        const valObj = this.get(key);
        if (valObj instanceof Set) {
            valObj.add(newVal);
        }
        else {
            throw Error('Cannot use append for non-set values');
        }
    }
    toMap() {
        return this.map;
    }
}
export const applySearchHighlight = (text, search) => _.map(getSearchMatchingSections(text, search), (match, i) => ({
    tag: 'span',
    key: i,
    cl: match.match ? 'highlight' : undefined,
    text: match.text,
}));
const getSearchMatchingSections = (text, search) => {
    if (text == null) {
        text = '';
    }
    if (!search || search.length === 0) {
        return [{ match: false, text }];
    }
    let haystack = text.toLowerCase();
    search = search.toLowerCase();
    const result_indices = Do(() => {
        const indices = [];
        let index_offset = 0;
        while (haystack.indexOf(search) !== -1) {
            const new_index = haystack.indexOf(search) + index_offset;
            indices.push(new_index);
            const index_offset_delta = haystack.indexOf(search) + search.length;
            index_offset += index_offset_delta;
            haystack = haystack.substring(index_offset_delta);
        }
        return indices;
    });
    const sections = [
        {
            match: false,
            text: text.substring(0, result_indices[0] ?? text.length + 1),
        },
    ];
    result_indices.forEach((index, n) => {
        const match_start = index;
        const match_end = index + search.length;
        sections.push({
            match: true,
            text: text.substring(match_start, match_end),
        });
        const next_match_start = result_indices[n + 1] ?? text.length + 1;
        sections.push({
            match: false,
            text: text.substring(match_end, next_match_start),
        });
    });
    return sections.filter(x => x.text.length > 0);
};
export const objDiff = (objA, objB) => {
    objA = _.cloneDeep(objA);
    const changes = (objA, objB) => _.transform(objA, (result, value, key) => {
        if (!_.isEqual(value, objB[key])) {
            result[key] = Do(() => {
                if (_.isObject(value) && _.isObject(objB[key])) {
                    return changes(value, objB[key]);
                }
                return value;
            });
        }
    });
    return changes(objA, objB);
};
export const isDarkTheme = () => {
    const theme = window.rootUI?.state?.theme ?? window.rootData?.Theme;
    return theme == 'black' || theme == 'dark';
};
//# sourceMappingURL=component-main.js.map